<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

<app-vt-toaster></app-vt-toaster>
<router-outlet></router-outlet>

<app-file-download></app-file-download>
